<ion-item lines="none" class="month-slider-item">

  <yu-icon
    slot="start"
    name="caret-left"
    color="dark"
    (click)="subtractMonth()"
  ></yu-icon>

  <ion-label (click)="openModalMonth()">
    {{ fromDate | date: "MMMM" }} - {{ fromDate | date: "yyyy" }}
  </ion-label>

  <yu-icon
    slot="end"
    name="caret-right"
    color="dark"
    (click)="addMonth()"
  ></yu-icon>

</ion-item>
